import Image from 'next/image';
import Link from 'next/link';

import { If, createComponent } from '@lib/util/templateHelpers';
import shared from '@lib/components';
const { Flex, Spacer } = shared;

import styles from './index.module.scss';

export default createComponent('GameTag', { styles }, function GameTag ({ className }, props) {
  return (
    <Link href={props.href} passHref onClick={props.onClick}>
      <a className={className}>
        <Flex tag='span' className='GameTag__Label' alignCenter justifyCenter>{props.children}</Flex>
        {
          If(props.thumbnailSrc, () => (
            <Flex tag='span' className='GameTag__Thumbnail'>
              <Spacer wide spacer={Spacer.ASPECT_1_1} />
              <Image
                src={props.thumbnailSrc}
                alt={props.alt}
                layout='fill'      
                objectFit='cover'
              />
            </Flex>
          ))
          .EndIf()
        }
      </a>
    </Link>
  );
});
